export default {
    zh: {
        DCApproval: 'DC主数据审批',
        DCManage: 'DC主数据管理',
        DCMaintain: 'DC主数据维护',
        DCDetail: 'DC主数据详情',
        MDMAdd: 'MDM新增',
        createDate: '创建日期',
        DcnumberExists: 'DC编码已存在',
        storageRatio: 'ADP仓储费占比',
        deliveryRatio: 'ADP运输费占比',
        adp: 'ADP（含税）',
        DCNumber: 'DC编码',
        DCType: 'DC类型',
        adpwotax: '生效ADP（不含税）',
        supplierName: 'DC名称',
        emailAddress: '邮箱',
        tmAreaId: '市/区',
        locationReference: 'LocationReference',
        locationReferenceRegionAdd: 'RegionAdd',
        carrierCode: 'DC供应商编号',
        carrierNmae: 'DC供应商名称',
        telephoneNo: '手机号',
        postCode: '邮政编码',
        address: '详细地址',
        supplierNameShort: 'DC简称',


    },
    en: {
        DCApproval: 'DCApproval',
        DCMaintain: 'DCMaintain',
        DCDetail: 'DCDetail',
        MDMAdd: 'MDMAdd',
        createDate: 'createDate',
        DcnumberExists: 'Dcnumber already exists',

    }
}